"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewPassword extends new_item_1.default {
    constructor(newPassword) {
        super();
        this.oldPassword = newPassword.oldPassword;
        this.newPassword = newPassword.newPassword;
        this.status = newPassword.status;
    }
}
exports.default = NewPassword;
//# sourceMappingURL=new-password.js.map